import { GlassCard } from "@/components/glass-card";
import { PRO_ACCOUNT_NOTE, pricingPlans } from "@/lib/pricing-copy";
import { Link } from "react-router-dom";

export function PricingPlans({
  signupBase = "/signup",
  showProNote = true,
}: {
  signupBase?: string;
  showProNote?: boolean;
}) {
  return (
    <div className="space-y-6">
      {showProNote ? (
        <p className="max-w-3xl text-sm text-slate-600 dark:text-slate-300">
          {PRO_ACCOUNT_NOTE}
        </p>
      ) : null}
      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {pricingPlans.map((plan) => (
          <GlassCard
            key={plan.id}
            className={plan.featured ? "ring-2 ring-teal-600/35" : undefined}
          >
            <p className="text-xs font-semibold uppercase tracking-wide text-teal-800 dark:text-teal-300">
              {plan.id === "byo_claude" ? "My Claude" : "Prime Pro"}
            </p>
            <h3 className="mt-1 text-xl font-semibold text-slate-900 dark:text-slate-50">
              {plan.name}
            </h3>
            <p className="mt-4 flex items-baseline gap-1">
              <span className="text-4xl font-semibold tracking-tight text-slate-900 dark:text-slate-50">
                {plan.price}
              </span>
              <span className="text-slate-500">{plan.period}</span>
            </p>
            <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
              {plan.blurb}
            </p>
            <ul className="mt-6 space-y-2 text-sm text-slate-700 dark:text-slate-200">
              {plan.highlights.map((item) => (
                <li key={item} className="flex gap-2">
                  <span className="text-teal-700 dark:text-teal-400" aria-hidden>
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <Link
                to={`${signupBase}?plan=${plan.id}`}
                className="inline-flex w-full items-center justify-center rounded-2xl bg-teal-700 px-6 py-4 text-base font-semibold text-white shadow-lg shadow-teal-700/20 hover:bg-teal-800"
              >
                {plan.cta}
              </Link>
            </div>
          </GlassCard>
        ))}
      </div>
    </div>
  );
}
